import stubTestServices from './boot/stub_tests.js';
import setStateCallbacks from './boot/state_callbacks.js';
import setupDeviceSize from './boot/device_size.js';
import setupSentry from './boot/sentry.js';
import httpConfig from './boot/http_config.js';
import setupDocument from './boot/document.js';
import setupSafeApply from './boot/safe_apply.js';
import setupFlashMessageEvents from './boot/flash_message_events.js';
import setupCurrentStateStore from './boot/current_state_store';

tiz.constant('C', require('./constants.js.erb'));

window.FlashService = null;
window.pendingRequests = {};

var run = function($injector, $rootScope, $location, Flash, $q, $animate, C, $timeout, $window, $state, $stateParams) {
  window.angularInjector = $injector;

  $rootScope.C = C;
  $rootScope.subNav = {};
  $rootScope.isArray = angular.isArray;
  window.FlashService = Flash;

  if (window.RAILS_ENV == 'test') {
    $animate.enabled(false);
    stubTestServices($q);
  }

  setStateCallbacks($rootScope, $location);
  // for passing to svelte land
  $window.stateService = $state;
  $window.stateParams = $stateParams;
  $window.locationService = $location;
  $window.$rootScope = $rootScope;
  $window.svelteModal = function(component, props) {
    new component({
      target: document.getElementById('programmatic-modal-container'),
      props: props
    })
  };
  setupSafeApply($rootScope, $timeout);
  setupDeviceSize($rootScope, $timeout);
  setupFlashMessageEvents($rootScope, $state, Flash);
  setupCurrentStateStore($rootScope);

  var isIE = (navigator.userAgent.indexOf("MSIE") != -1);

  if (isIE) {
    document.cookie = "cookietest=1";
    var hasCookies = document.cookie.indexOf("cookietest=") !== -1;
    $rootScope.showCookieWarning = hasCookies;
  } else if (navigator.cookieEnabled === false) {
    $rootScope.showCookieWarning = true;
  }
};

run.$inject = ['$injector', '$rootScope', '$location', 'Flash', '$q', '$animate', 'C', '$timeout', '$window', '$state', '$stateParams'];

tiz.run(run);

var config = function(C, $provide, $httpProvider, $injector, hotkeysProvider, cfpLoadingBarProvider) {
  setupSentry(C, $provide);

  httpConfig(C, $provide, $httpProvider);

  hotkeysProvider.useNgRoute = false;
  if (!_.includes((window.location || {}).href, '/admin')) {
    hotkeysProvider.includeCheatSheet = false;
  };

  cfpLoadingBarProvider.includeSpinner = false;
  cfpLoadingBarProvider.parentSelector = '#admin-loading-bar-container';
  if (!_.includes((window.location || {}).href, '/admin')) {
    hotkeysProvider.includeBar = false;
  };
};

config.$inject = ['C', '$provide', '$httpProvider', '$injector', 'hotkeysProvider', 'cfpLoadingBarProvider'];

tiz.config(config);

tiz.config(['C', '$provide', '$httpProvider', '$injector', 'hotkeysProvider', 'cfpLoadingBarProvider', function(C, $provide, $httpProvider, $injector, hotkeysProvider, cfpLoadingBarProvider) {
}]);

angular.element(document).ready(function() {
  angular.bootstrap(document, ['tiz'], {
    strictDi: true
  });
});

setupDocument();

